module.exports = __webpack_public_path__ + "img/logo-dentaluni.2ca2dfc7.jpg";